import { buildApiUrl, requestJson } from "../dataProvider/requestJson";
import { GET_VENUE } from "../constants/endpoints";
import { buildQuery } from "./teamAdminApi";

/**
 * Admin venue list (`/restapi/admin/venues`, system administrators only).
 * Contract: DIVE-6877 spec §3.1 (Backend `docs/drafts/DIVE-6877-venues-admin-filters.md`).
 */
const BASE = "admin/venues";

const STATUS_MESSAGES = {
  401: "Your session has expired. Log in again.",
  403: "Only system administrators can manage venues.",
};

export const venueAdminApi = {
  /**
   * @returns {Promise<{totalPages, currentPage, totalElements, dtos}>}
   * Rows are `AdminVenueRowDTO`s: flat address fields plus `countryIso`/`countryName`.
   */
  list: (params) =>
    requestJson(
      buildApiUrl(`${BASE}${buildQuery(params)}`),
      undefined,
      STATUS_MESSAGES,
    ),

  /** @returns {Promise<{countries: {code, name, count}[]}>} */
  filterOptions: () =>
    requestJson(
      buildApiUrl(`${BASE}/filter-options`),
      undefined,
      STATUS_MESSAGES,
    ),

  /**
   * The full `VenueDTO` (with the nested `addressDto`) for the edit form. The list row
   * no longer carries email, backup email or mobile phone, so the form loads this instead.
   */
  get: (id) =>
    requestJson(buildApiUrl(GET_VENUE(id)), undefined, STATUS_MESSAGES),
};
